import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PromotionCampaignDetailModel } from '../../../../../../models/promotion-campaign.model';
import { PromotionCampaignDetailService } from '../../../../../../services/promotion/promotion-campaign-detail.service';
import { DivisionSalesNetworkService } from '../../../../../../services/division-sales-network/divison-sales-network.service';
import { PromotionMessageService } from '../../../../../../services/promotion/promotion-message.service';
import { TranslateService } from '@ngx-translate/core';
import { PromotionWizardService } from '../../../../../../services/promotion/promotion-wizard.service';
import { PromotionDiscountTypeService } from '../../../../../../services/promotion/promotion-discount-type.service';
import { PromotionLayoutService } from '../../../../../../services/promotion/promotion-layout.service';
import { PromotionTouchPointService } from '../../../../../../services/promotion/promotion-touch-point.service';
import { PromotionMessageTypeService } from '../../../../../../services/promotion/promotion-message-type.service';
import { LoyaltyClusterService } from '../../../../../../services/loyalty/loyalty-cluster.service';
import { PromotionTemplateService } from '../../../../../../services/promotion/promotion-template.service';
import { LoyaltyParamsService } from '../../../../../../services/loyalty/params.service';

@Component({
  selector: 'kv-promo-tab-detail',
  template: `
      <app-kontable
              title="{{ 'customerShoppingHabits.details' | translate }}"
              [columns]="[
        'message_id',
        {
            field: 'start_date',
            title: 'customerInfoSheet.startDate',
            bodyTemplate: dateStart
        },
        {
            field: 'end_date',
            title: 'customerInfoSheet.endDate',
            bodyTemplate: dateEnd
        }
        ]"
              [titles]="['promotion.message']"
              [source]="details"
              [showInfoButton]="true"
              [showRecoverButton]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [showGlobalFilter]="false"
              [showEditButton]="true"
              (onRemove)="deleteDetail($event['id'])"
              (onAdd)="showDetailAdd()"
              (onEdit)="showDetailEdit($event)"
              *ngIf="showKontable"
              [name]="'promotion.messageTable'">
          <ng-template #dateStart let-row>
              {{ row['start_date'] | date: 'yyyy-MM-dd' }}
          </ng-template>
          <ng-template #dateEnd let-row>
              {{ row['end_date'] | date: 'yyyy-MM-dd' }}
          </ng-template>
      </app-kontable>
      <kv-promo-tab-detail-form
              *ngIf="showForm"
              [titlePage]="titlePage"
              [addEditDetail]="addEditDetail"
              (backToKontable)="toggleForm(); toggleKontable()"
              [addEditCampaign]="addEditCampaign"
              [configs]="configs"
              [divisionSaleNetworkItems]="divisionSaleNetworkItems"
              [messages]="messages"
              (saveDetail)="saveThisDetail($event)"
              (showNewMessage)="createNewMessage($event)">
      </kv-promo-tab-detail-form>
      <kv-promo-message-detail
              *ngIf="showNewMessage"
              (shortInsertCompleted)=" shortInsertCompleted($event)"
              [shortInsert]="shortInsert"
              [wizards]="wizards"
              [editMessage]="editMessage"
              [discountTypes]="discountTypes"
              [messagesTypes]="messagesTypes"
              [barCodes]="barCodes"
              [clusters]="clusters"
              [templates]="templates"
              [touchPoints]="touchPoints"
              [layouts]="layouts">
      </kv-promo-message-detail>
  `
})
export class TabDetailComponent implements OnInit, OnChanges {

  @Input() addEditCampaign;
  @Input() configs;

  showForm = false;
  showNewMessage = false;
  showKontable = true;


  addEditDetail: PromotionCampaignDetailModel;
  titlePage = '';
  details: PromotionCampaignDetailModel[];
  shortInsert = true;
  editMessage = null;
  messageId = null;

  divisionSaleNetworkItems = [];
  messages;
  wizards;
  discountTypes;
  messagesTypes;
  barCodes;
  clusters;
  templates;
  layouts;
  touchPoints;

  chooseMessage;
  chooseWizard;
  chooseDiscount;
  chooseMessageType;
  chooseBarCode;
  chooseCluster;
  chooseTemplate;
  chooseLayout;
  chooseTouchPoint;

  constructor(private svcCampaignDetail: PromotionCampaignDetailService,

              private svcDivisionSalesNetwork: DivisionSalesNetworkService,
              private svcMessage: PromotionMessageService,
              private svcWizard: PromotionWizardService,
              private svcDiscountType: PromotionDiscountTypeService,
              private svcMessageType: PromotionMessageTypeService,
              private svcParams: LoyaltyParamsService,
              private svcCluster: LoyaltyClusterService,
              private svcTemplate: PromotionTemplateService,
              private svcLayout: PromotionLayoutService,
              private svcTouchPoint: PromotionTouchPointService,
              private srvTranslate: TranslateService
  ) {
    srvTranslate.get(['promotion.chooseMessage']).subscribe((res) => {
      this.chooseMessage = res['promotion.chooseMessage']
    });
    srvTranslate.get(['promotion.chooseWizard']).subscribe((res) => {
      this.chooseWizard = res['promotion.chooseWizard']
    });
    srvTranslate.get(['promotion.chooseDiscount']).subscribe((res) => {
      this.chooseDiscount = res['promotion.chooseDiscount']
    });
    srvTranslate.get(['promotion.chooseMessageType']).subscribe((res) => {
      this.chooseMessageType = res['promotion.chooseMessageType']
    });
    srvTranslate.get(['promotion.chooseBarCode']).subscribe((res) => {
      this.chooseBarCode = res['promotion.chooseBarCode']
    });
    srvTranslate.get(['promotion.chooseCluster']).subscribe((res) => {
      this.chooseCluster = res['promotion.chooseCluster']
    });
    srvTranslate.get(['promotion.chooseTemplate']).subscribe((res) => {
      this.chooseTemplate = res['promotion.chooseTemplate']
    });
    srvTranslate.get(['promotion.chooseLayout']).subscribe((res) => {
      this.chooseLayout = res['promotion.chooseLayout']
    });
    srvTranslate.get(['promotion.chooseTouchPoint']).subscribe((res) => {
      this.chooseTouchPoint = res['promotion.chooseTouchPoint']
    });

    svcDivisionSalesNetwork.getListExpanded().subscribe(dsn_list => {
      dsn_list.forEach(dsn => {
        this.divisionSaleNetworkItems.push({
          value: dsn.id,
          label: dsn.division_name + ' - ' + dsn.sales_network_name
        })
      })
    });
    svcMessage.list().subscribe( (res) => {
      this.messages = [{label: this.chooseMessage, value: null}];
      /*filtro quelli che non sono stati eliminati*/
      let newArray = res.data.filter( function (e) {
        return e['flg_state'] === '0'
      });
      /*riempio il vettore*/
      for (let elem of newArray) {
        this.messages.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcWizard.list(0, 999999, [
      {
        key: 'type',
        value: 'message'
      }
    ]).subscribe(res => {
      this.wizards = [{label: this.chooseWizard, value: null}];
      for (let elem of res.data) {
        this.wizards.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcDiscountType.list(0, 999999).subscribe( (res) => {
      this.discountTypes = [{label: this.chooseDiscount, value: null}];
      for (let elem of res.data) {
        this.discountTypes.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcMessageType.list(0, 999999).subscribe( (res) => {
      this.messagesTypes = [{label: this.chooseMessage, value: null}];
      for (let elem of res.data) {
        this.messagesTypes.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcParams.list(0, 999999, [
      {
        key: 'param_group',
        value: 'MessageBarCodeType'
      }
    ]).subscribe(p => {
      this.barCodes = [{label: this.chooseBarCode, value: null}];
      for (let elem of p.data) {
        this.barCodes.push({
          label: elem.description,
          value: elem.id
        })
      }
    });
    svcCluster.list(0, 999999).subscribe( (res) => {
      this.clusters = [{label: this.chooseCluster, value: null}];
      for (let elem of res.data) {
        this.clusters.push({
          //label: elem.type + ' - ' + elem.description,
          label: elem.cluster_type_code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcTemplate.list(0, 999999).subscribe( (res) => {
      this.templates = [{label: this.chooseTemplate, value: null}];
      for (let elem of res.data) {
        this.templates.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcLayout.list(0, 999999).subscribe( (res) => {
      this.layouts = [{label: this.chooseLayout, value: null}];
      for (let elem of res.data) {
        this.layouts.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcTouchPoint.list(0, 999999).subscribe( (res) => {
      this.touchPoints = [{label: this.chooseTouchPoint, value: null}];
      for (let elem of res.data) {
        this.touchPoints.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['addEditCampaign'] &&
      changes['addEditCampaign'].currentValue &&
      changes['addEditCampaign'].currentValue !== null
    ) {
      this.reloadList(changes['addEditCampaign'].currentValue.id);
    }
  }

  deleteDetail(id) {
    this.svcCampaignDetail.delete(id).subscribe( () => {
      this.reloadList(this.addEditCampaign.id);
    });
  }

  showDetailAdd() {
    this.titlePage = 'promotion.addDetail';
    this.addEditDetail = null;
    this.toggleForm();
    this.toggleKontable()
  }

  showDetailEdit(item) {
    this.titlePage = 'promotion.editDetail';
    this.svcCampaignDetail.get(item.id).subscribe((res) => {
      this.addEditDetail = res;
      this.toggleForm();
      this.toggleKontable()
    })
  }

  toggleForm() {
    this.showForm = !this.showForm;
  }

  toggleNewMessage() {
    this.showNewMessage = !this.showNewMessage;
  }

  toggleKontable() {
    this.showKontable = !this.showKontable;
  }

  reloadList(id) {
    this.details = [];
    this.svcCampaignDetail.list().subscribe((res) => {
      this.details = res.data.filter( function (e) {
        return e.campaign_id === id &&
          e['flg_state'] === '0'
      });
    })
  }

  saveThisDetail(item: PromotionCampaignDetailModel) {
    if (!item.id) {
      this.svcCampaignDetail.create(item).subscribe( () => {
        this.reloadList(this.addEditCampaign.id);
        this.toggleForm();
        this.toggleKontable();
      })
    } else {
      this.svcCampaignDetail.update(item).subscribe( () => {
        this.reloadList(this.addEditCampaign.id);
        this.toggleForm();
        this.toggleKontable();
      })
    }
  }

  createNewMessage(tempFormValues: PromotionCampaignDetailModel) {
    this.addEditDetail = tempFormValues;
    this.toggleForm();
    this.toggleNewMessage();
  }

  shortInsertCompleted(id) {
    this.addEditDetail.message_id = id;
    this.svcMessage.list().subscribe( (res) => {
      this.messages = [{label: this.chooseMessage, value: null}];
      /*filtro quelli che non sono stati eliminati*/
      let newArray = res.data.filter( function (e) {
        return e['flg_state'] === '0'
      });
      /*riempio il vettore*/
      for (let elem of newArray) {
        this.messages.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
      this.toggleNewMessage();
      this.toggleForm()
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/detail/tab-detail.component.ts